import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import ProjectModel from 'models/Project';

import Wrapper from './styled/Wrapper';
import Client from './styled/Client';
import Heading from './styled/Heading';
import Copy from './styled/Copy';
import Title from './styled/Title';
import Project from './styled/Project';
import ProjectThumbnailWrapper from './styled/ProjectThumbnailWrapper';
import ProjectThumbnail from './styled/ProjectThumbnail';
import Content from './styled/Content';
import Header from './styled/Header';
import Description from './styled/Description';
import LinkMore from './styled/LinkMore';
import InnerWrapper from './styled/InnerWrapper';

export default class CaseStudy extends Component {
  static defaultProps = {
    copyTitle: 'Case Study',
    copyClient: 'In collaboration with',
    copyProject: 'Project',
    buttonLabel: 'more',
  };

  static contextType = ThemeContext;

  render() {
    const {
      project,
      className,
      copyTitle,
      copyClient,
      copyProject,
      buttonLabel,
      baseLink,
    } = this.props;
    const { name, image, clients, caseStudy, slug } = project;

    const brand = clients[0]?.name;

    return (
      <Wrapper className={className}>
        <Content>
          <Header>
            <Title theme={this.context}>{copyTitle}</Title>

            {brand && <Client>
              <Heading theme={this.context}>{copyClient}</Heading>
              <Copy theme={this.context}>{brand}</Copy>
            </Client>}

            <Project>
              <Heading theme={this.context}>{copyProject}</Heading>
              <Copy theme={this.context} projectName>{name}</Copy>
            </Project>
          </Header>

          <InnerWrapper>
            <ProjectThumbnailWrapper>
              <ProjectThumbnail src={image.url} />
            </ProjectThumbnailWrapper>

            {caseStudy && <Description theme={this.context}>{caseStudy.processDescription}</Description>}

            <LinkMore
              label={buttonLabel}
              link={{
                pathname: `${baseLink}/[slug]`,
                query: {
                  slug,
                },
              }}
              linkAs={`${baseLink}/${slug}`}
            />
          </InnerWrapper>
        </Content>
      </Wrapper>
    );
  }
}
